// import { RouteConfig } from 'react-router-config'
import React from 'react'
import { useSelector } from '@/store'
import { useCallback } from 'react'
import { shallowEqual } from 'react-redux'
import { Redirect } from 'react-router'

// type InterceptorConfigure = (route: RouteConfig, context: Record<string, any>) => RouteConfig[]

export const interceptor = (route, context) => {
  const hasPermission = context?.permission?.[route.authCode] || false
  return hasPermission ? route : null
}

/** 权限拦截器 */
export function usePermission() {
  const resourceMap = useSelector((state) => state.auth.authResource, shallowEqual)
  return useCallback(
    (route) => {
      const { authCode } = route

      if (!authCode) return route

      const hasAuth = resourceMap?.[authCode]
      return hasAuth
        ? route
        : {
            path: route.path,
            component() {
              return <Redirect to="/noAuth/simple" />
            },
            /** exact -> true 精准匹配 */
            exact: route.exact,
          }
    },
    [resourceMap]
  )
}
